import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { compStyles } from '../styleBased/compStylesCompNode'
import type { FontFacesCssFeature } from './fontFaces.types'
import { fontFacesCss } from './fontFacesCssCompNode'
import { fontFacesDomApplier } from './fontFacesDomApplier'
import { fontFamilies } from './fontFamiliesCompNode'
import { innerElementsStyles } from '../styleBased/compThemeCompNode'

export const fontFacesCssFeature: FontFacesCssFeature = {
	featureName: 'fontFaces',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { fontFamilies, fontFacesCss: fontFacesCss(false) },
	intermediateNodes: { compStyles, innerElementsStyles },
	dataMaps: ['theme_data', 'document_data', 'design_data', 'variables'],
	domApplier: fontFacesDomApplier,
}

export const editorFontFacesCssFeature: FontFacesCssFeature = {
	...fontFacesCssFeature,
	renderableNodes: { ...fontFacesCssFeature.renderableNodes, fontFacesCss: fontFacesCss(true) },
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(fontFacesCssFeature)
}

export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorFontFacesCssFeature)
}
